var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "787px",
    height: "787px",
    viewBox: "0 0 787 787",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(539.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.96922,67.302549 C106.972099,98.5888477 81.9941961,119.56223 52.1902238,114.148844 C22.3862515,108.735459 -0.966342326,78.9837497 0.0307795298,47.697451 C1.02790139,16.4111523 26.0058039,-4.56222957 55.8097762,0.851155536 C85.6137485,6.26553648 108.966342,36.0162503 107.96922,67.302549",
    id: "Fill-172",
    fill: "#51DEA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5449592,45.6159719 L41.5271573,79.7606479 C42.2350019,81.0284521 43.541025,81.867062 44.9965927,81.9857332 C46.4521604,82.1034155 47.8778192,81.4873141 48.7750869,80.3500483 L76.0619967,46.0105537 C77.557443,44.1325817 77.2284448,41.4100662 75.3342128,39.9296428 C73.4399809,38.4492194 70.6983294,38.7716095 69.2028831,40.6495815 L45.9935569,69.8624795 L30.1817049,41.4328115 C29.0252264,39.3392535 26.3633321,38.5777798 24.2597376,39.7328464 C22.1461736,40.8879129 21.3785111,43.521425 22.5449592,45.6159719",
    id: "Fill-173",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.bbf3fbd62b3a9ac5a298eef44841aba5.svg";
export { ForwardRef as ReactComponent };